export const getExactError = (err) => {
    if (!err) return "Something went wrong";

    if (err.response) return (err?.response?.data?.message || err?.response.data || "Server error");
    
    if (err.message) return err.message;

    if (err.request) return "Network error. Please check your internet connection.";


    if (typeof err === "string") return err;

    return "Unexpected error occurred";
};
